module.exports = __webpack_public_path__ + "static/business_kvM@2x-9557d0520830a2a374ecf7c5dd3cc250.png";